import { render, staticRenderFns } from "./ArticleSidebar.vue?vue&type=template&id=1a211f51&"
import script from "./ArticleSidebar.vue?vue&type=script&lang=ts&"
export * from "./ArticleSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleSidebar.vue?vue&type=style&index=0&id=1a211f51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports